/**
 * Pure helpers for the grouped tracking-drop feed card. A `carrier_tracking_drop`
 * root ("ZIM dropped from tracking — N bookings") expands to a single
 * `tracking_drop` effect that carries the affected bookings. Kept separate from
 * the component so they can be unit-tested without a DOM.
 */
import type { TrackingDropPayload } from "@/types/feed";

/** Whether an effect payload is a grouped tracking-drop breakdown. */
export function isTrackingDropPayload(
  payload: unknown,
): payload is TrackingDropPayload {
  if (!payload || typeof payload !== "object") return false;
  const p = payload as Record<string, unknown>;
  return p.kind === "tracking_drop" && Array.isArray(p.bookings);
}
